import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import { Creators } from "./model"
import { Creators as notificationsCreators } from "modules/notifications/model"
import { Creators as DialogCreators } from "modules/dialog/model"
import withOutletContext from "hocs/withOutletContext"
import {
  getApplications,
  getAccountApiAccess,
  getIsSuperuser,
  getSortedIntegrations,
  getPartnerTerms,
  getAlphaTheoryStatus,
  getATTerms,
  getAlphaTheoryTermsVersion,
  getEzeStatus,
  getEzeTerms,
  getEzeTermsVersion,
  getAiPermissionGranted,
  getAiTerms,
  getAiTermsVersion,
} from "./selectors/apps"

export default withOutletContext(createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
    revision: state.modules.platform.revision,
  }),
  required: ["account"],
  data: [{
    resource: "applications",
    as: null,
    url: ({ account, revision }) => `/api/${account}/applications?revision=${revision}`,
  }, {
    resource: "atTerms",
    url: ({ account }) => `/api/${account}/terms?license=alpha_theory`,
  }, {
    resource: "ezeTerms",
    url: ({ account }) => `/api/${account}/terms?license=eze`,
  }, {
    resource: "partnerTerms",
    url: ({ account }) => `/api/${account}/terms?license=partner`,
  }, {
    resource: "aiTerms",
    url: ({ account }) => `/api/${account}/terms?license=ompnt_ai`,
  }, {
    resource: "aiPermissionGranted",
    // This will prevent the page from refreshing when we resetCollections('aiPermissionGranted') after activation
    passthrough: true,
    url: ({ account }) => `/api/${account}/aiPermission`,
  }, {
    resource: "alphaTheoryMetadata",
    url: ({ account }) => {
      if (!account) {
        return null
      }
      return ({
        id: `alphaTheoryMetadata-${account}`,
        url: `/api/${account}/partners/meta?partnerType=alpha_theory`,
      })
    },
  }, {
    resource: "ezeMetadata",
    url: ({ account }) => {
      if (!account) {
        return null
      }
      return ({
        id: `ezeMetadata-${account}`,
        url: `/api/${account}/partners/meta?partnerType=eze`,
      })
    },
  }, {
    resource: "integrations",
    as: null,
    url: ({ account }) => `/api/${account}/accountPartners`,
  }],
  mapStateToProps: (state, props) => ({
    user: state.user,
    apps: getApplications(state, props),
    alphaTheoryStatus: getAlphaTheoryStatus(state, props),
    alphaTheoryTerms: getATTerms(state, props),
    alphaTheoryTermsVersion: getAlphaTheoryTermsVersion(state, props),
    ezeStatus: getEzeStatus(state, props),
    ezeTerms: getEzeTerms(state, props),
    ezeTermsVersion: getEzeTermsVersion(state, props),
    legalAccountName: get(state, "global.selected.accountMeta.legalName"),
    hasApiAccess: getAccountApiAccess(state, props),
    isSuperuser: getIsSuperuser(state, props),
    sortedIntegrations: getSortedIntegrations(state, props),
    partnerTerms: getPartnerTerms(state, props),
    aiTerms: getAiTerms(state, props),
    aiTermsVersion: getAiTermsVersion(state, props),
    isAiPermissionGranted: getAiPermissionGranted(state, props),
  }),
  actions: {
    ...Creators,
    openDialog: DialogCreators.open,
    closeDialog: DialogCreators.close,
    addNotification: notificationsCreators.add,
  },
}))
